import { useEffect, useState } from "react";

const cache = new Map();

export const SAMPLE_QR_VALUE =
  "https://verify.credissuer.com/credentials/sample";

/** Renders a styled QR (same library as certificate onboarding) to a data URL. */
export async function createQrDataUrl({
  value = SAMPLE_QR_VALUE,
  fg = "#111827",
  bg = "#ffffff",
  dotStyle = "square",
  size = 512,
}) {
  const key = `${value}|${fg}|${bg}|${dotStyle}|${size}`;
  if (cache.has(key)) return cache.get(key);
  const { default: QRCodeStyling } = await import("qr-code-styling");
  const qr = new QRCodeStyling({
    width: size,
    height: size,
    type: "canvas",
    data: value,
    margin: 8,
    qrOptions: { errorCorrectionLevel: "M" },
    dotsOptions: { type: dotStyle, color: fg },
    cornersSquareOptions: { color: fg },
    cornersDotOptions: { color: fg },
    backgroundOptions: { color: bg },
  });
  const blob = await qr.getRawData("png");
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  cache.set(key, dataUrl);
  return dataUrl;
}

export function useQrDataUrl(options) {
  const { value, fg, bg, dotStyle } = options;
  const [dataUrl, setDataUrl] = useState(null);
  useEffect(() => {
    let cancelled = false;
    createQrDataUrl({ value, fg, bg, dotStyle })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [value, fg, bg, dotStyle]);
  return dataUrl;
}
